import { ResponsiveLine } from "@nivo/line";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

  export const WeekDayChart = ({ dataValues = [] }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dateValues = dataValues[0].data.map((item) => item.x);
  // Calculate the number of data points and determine the tick interval
  const numberOfDataPoints = dateValues.length;
  const tickInterval = Math.max(Math.floor(numberOfDataPoints / 25), 1); // Adjust 10 as needed
  // Create an array of tick values
  const tickValues = dateValues.filter((_, index) => index % tickInterval === 0);
  const unit = dataValues[0].unit;
  
  return (
    <ResponsiveLine
      data={dataValues}
      enablePoints={true}
      theme={{
        axis: {
          domain: {
            line: {
              stroke: colors.grey[100],
            },
          },
          legend: {
            text: {
              fill: colors.grey[100],
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[100],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[100],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[100],
          },
        },
        tooltip: {
          container: {
            color: colors.primary[500],
          },
        },
      }}
      colors={row => row.color}
      margin={{ top: 70, right: 100, bottom: 100, left: 70 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        reverse: false,
      }}
      yFormat=" >-.2f"
      curve="catmullRom"
      tooltip={(point) => {
        const shortName = dataValues.find(row => row["id"] === point.point.serieId)["pointShortName"]
        const unit = dataValues.find(row => row["id"] === point.point.serieId)["unit"]
        return (
          <Box sx={{ backgroundColor: "white", color: "black", padding: "10px", borderRadius: "5px", boxShadow:3, opacity:0.9, display:'flex'}}>
             <Box sx={{width:'10px', height:'40px', backgroundColor: point.point.color, margin:'auto', marginRight:'9.9px', borderRadius:'3px'}}></Box>
             {shortName}: {point.point.data.yFormatted}{unit}<br/>
             {point.point.data.xFormatted} 
          </Box>
        );
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickSize: 5,
        tickPadding: 10,
        tickRotation: 40,
        tickValues: tickValues 
      }}
      axisLeft={{
        orient: "left",
        tickValues: 6, 
        tickSize: 3,
        tickPadding: 5,
        tickRotation: 0,
        format: (value) => `${value}${unit}`
      }}
      enableGridX={false}
      enableGridY={true}
      pointSize={6}
      pointBorderWidth={2}
      pointLabelYOffset={-12}
      useMesh={true}
      legends={[
        {
          data: dataValues.map((row) => {
            return {
              color:row["color"],
              label:row["pointShortName"]
            }
          }),
          anchor: "top-right",
          direction: "column",
          justify: false,
          translateX: 70,
          translateY: -60,
          itemsSpacing: 15,
          itemDirection: "left-to-right",
          itemWidth: 70,
          itemHeight: 0,
          itemOpacity: 1,
          symbolSize: 13,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};
